class SellingPlansWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.ensureSingleSellingPlanInput();
    this.enablePerformanceObserver();
    this.appendSellingPlanInputs();
    this.updateSellingPlanInputsValues();
    this.listenToVariantChange();
    this.listenToSellingPlanFormRadioButtonChange();
    this.selectFirstSubscriptionOption();
    this.listenToSellingPlanItemClick();
    this.listenToSellingPlanGroupListClick();
    this.checkForOnePlanOnly();

    // add optional-variant listener
    if (typeof this._onOptionalVariantChange === 'function') {
      this._onOptionalVariantChange = this._onOptionalVariantChange.bind(this);
      if (this.shopifySection) {
        this.shopifySection.addEventListener('variant-optional:change', this._onOptionalVariantChange);
      }
    }
  }

  disconnectedCallback() {
    if (this.shopifySection) {
      this.shopifySection.removeEventListener('variant-optional:change', this._onOptionalVariantChange);
    }
  }

  _onOptionalVariantChange(event) {
    if (this.isSellingPlansFromOptionals) {
      this._hydrateSubscriptionSelectorFromOptionals(event.detail);
    }
    this.updatePrice();
    this.toggleWidgetElement();
  }

  toggleWidgetElement() {
    const widgetElement = this.shopifySection.querySelector('.selling-plan-widget--container');
    let noMainElementWidget = widgetElement.dataset.noMainElementPlan === 'true';

    const anyOptionalChecked = this.shopifySection.querySelector('.optional-items__wrapper input:checked');
    if (noMainElementWidget) {
      if (anyOptionalChecked) {
        widgetElement.classList.remove('hidden');
      } else {
        widgetElement.classList.add('hidden');
      }
    }

  }

  _hydrateSubscriptionSelectorFromOptionals(details) {
    const selectElements = this.shopifySection?.querySelectorAll('select[name="selling_plan"]');
    if (!selectElements) return;

    const options = details.input
    .closest('.optional_product')
    .querySelectorAll('option');

    selectElements.forEach((selectElement) => {
      selectElement.replaceChildren()
      selectElement.append(...Array.from(options, (opt) => opt.cloneNode(true)));
      selectElement.dispatchEvent(new Event('change', { bubbles: true }));
    });

  }

  checkForOnePlanOnly() {
    const OnlyOnePlan = this.querySelectorAll('.selling-plan__group-size-1');

    OnlyOnePlan.forEach(elem => {
      let OnlyOnePlanItemValue = elem.querySelector('.selling_plan__item input')
      const newLi = document.createElement('li');
      newLi.textContent = OnlyOnePlanItemValue.dataset.currentName; // Set the content of the new <li>
      let sellingPlanList = elem.closest('.selling_plan__group-list')
      if (sellingPlanList.dataset.enableSave === 'true') {
        sellingPlanList.querySelector('.selling_plan__item--content ul').append(newLi);
      }
    });
  }

  ensureSingleSellingPlanInput() {
    let sellingPlanInput = this.querySelector('.selected-selling-plan-id');
    if (!sellingPlanInput) {
      sellingPlanInput = document.createElement('input');
      sellingPlanInput.name = 'selling_plan';
      sellingPlanInput.className = 'selected-selling-plan-id';
      sellingPlanInput.type = 'hidden';
      this.appendChild(sellingPlanInput);
    }
  }

  listenToSellingPlanGroupListClick() {
    this.shopifySection.querySelectorAll('.selling_plan__group-list').forEach(groupList => {
      groupList.addEventListener('click', (event) => {
        // Check if the click is not inside selling_plan__group-list--wrapper
        if (!event.target.closest('.selling_plan__group-list--wrapper')) {
          const wrapper = groupList.querySelector('.selling_plan__group-list--wrapper');
          if (wrapper) {
            // Check if any radio button is already selected
            const selectedRadioButton = wrapper.querySelector('input[type="radio"]:checked');
            if (!selectedRadioButton) {
              const firstItem = wrapper.querySelector('.selling_plan__item');
              if (firstItem) {
                const radioButton = firstItem.querySelector('input[type="radio"]');
                if (radioButton) {
                  radioButton.click();
                }
              }
            }
          }
        }
      });
    });
  }

  listenToSellingPlanItemClick() {
    this.shopifySection.querySelectorAll('.selling_plan__item').forEach(item => {
      item.addEventListener('click', () => {
        const radioButton = item.querySelector('input[type="radio"]');
        if (radioButton) {
          radioButton.click();
        }
      });
    });
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }

  get shopifySection() {
    return document.querySelector(`#shopify-section-${this.sectionId}`);
  }

  get variantIdInput() {
    return (
      this.addToCartForms[1]?.querySelector(`input[name="id"]`) ||
      this.addToCartForms[1]?.querySelector(`select[name="id"]`) ||
      this.addToCartForms[0].querySelector(`input[name="id"]`) ||
      this.addToCartForms[0].querySelector(`select[name="id"]`)
    );
  }

  get isSellingPlansFromOptionals() {
    return this.getAttribute('data-selling-plans-from-optionals') === 'true';
  }

  get priceElement() {
    return this.shopifySection.querySelector('.price');
  }

  get comparedAtPrice() {
    return this.shopifySection.querySelector('.price__sale');
  }

  get visibleSellingPlanForm() {
    return this.shopifySection.querySelector(
      `section[data-variant-id^="${this.variantIdInput.value}"]`,
    );
  }

  get isVariantAvailable() {
    return this.selectedPurchaseOption.getAttributeNames().includes('disabled');
  }

  get sellingPlanInput() {
    return this.shopifySection.querySelector('.selected-selling-plan-id');
  }

  get addToCartForms() {
    return this.shopifySection.querySelectorAll('[action*="/cart/add"]');
  }

  appendSellingPlanInputs() {
    this.addToCartForms.forEach((addToCartForm) => {
      const existingInput = addToCartForm.querySelector('.selected-selling-plan-id');
      if (!existingInput) {
        addToCartForm.appendChild(this.sellingPlanInput.cloneNode());
      }
    });
  }

  showSellingPlanForm(sellingPlanFormForSelectedVariant) {
    if (sellingPlanFormForSelectedVariant) {
      sellingPlanFormForSelectedVariant.classList.remove('selling_plan_theme_integration--hidden');

      // Select the first radio button in the form
      const firstRadioButton = sellingPlanFormForSelectedVariant.querySelector('input[type="radio"]');
      if (firstRadioButton) {
        firstRadioButton.checked = true;
        this.handleRadioButtonChange(firstRadioButton);
      }
    }
  }

  hideSellingPlanForms(sellingPlanFormsForUnselectedVariants) {
    sellingPlanFormsForUnselectedVariants.forEach((element) => {
      element.classList.add('selling_plan_theme_integration--hidden');
    });
  }

  handleSellingPlanFormVisibility() {
    const sellingPlanFormForSelectedVariant = this.shopifySection.querySelector(
      `section[data-variant-id="${this.variantIdInput.value}"]`,
    );
    const sellingPlanFormsForUnselectedVariants =
      this.shopifySection.querySelectorAll(
        `.selling_plan_theme_integration:not([data-variant-id="${this.variantIdInput.value}"])`,
      );
    this.showSellingPlanForm(sellingPlanFormForSelectedVariant);
    this.hideSellingPlanForms(sellingPlanFormsForUnselectedVariants);

  }

  handleVariantChange() {
    this.handleSellingPlanFormVisibility();
    this.updateSellingPlanInputsValues();
    this.listenToSellingPlanFormRadioButtonChange();
    this.updateMirrorPrice(this.selectedPurchaseOptionPrice);
  }

  listenToVariantChange() {
    this.listenToAddToCartForms();
    if (this.variantIdInput.tagName === 'INPUT') {
      const variantIdObserver = new MutationObserver((mutationList) => {
        mutationList.forEach((mutationRecord) => {
          this.handleVariantChange(mutationRecord.target.value);
        });
      });

      variantIdObserver.observe(this.variantIdInput, {
        attributes: true,
      });
    }
  }

  listenToAddToCartForms() {
    this.addToCartForms.forEach((addToCartForm) => {
      addToCartForm.addEventListener('change', () => {
        this.handleVariantChange();
      });
    });
  }

  get regularPriceElement() {
    return this.shopifySection.querySelector('.price__regular');
  }

  get salePriceElement() {
    return this.shopifySection.querySelector('.price__sale');
  }

  get salePriceValue() {
    return this.salePriceElement.querySelector('.price-item--sale');
  }

  get regularPriceValue() {
    return this.salePriceElement.querySelector('.price-item--regular');
  }

  get sellingPlanAllocationPrice() {
    return document.getElementById(
      `${this.selectedPurchaseOption.dataset.sellingPlanGroupId}_allocation_price`,
    );
  }

  get selectedPurchaseOptionPrice() {
    return this.selectedPurchaseOption.dataset.variantPrice;
  }

  get selectedPurchaseOptionPriceAmount() {
    return this.selectedPurchaseOption.dataset.variantPriceAmount;
  }

  get selectedPurchaseOptionComparedAtPrice() {
    return this.selectedPurchaseOption.dataset.variantCompareAtPrice;
  }

  get selectedPurchaseOptionComparedAtPriceAmount() {
    return this.selectedPurchaseOption.dataset.variantCompareAtPriceAmount;
  }

  get price() {
    return this.sellingPlanAllocationPrices.price ?? null;
  }

  updatePrice() {

    if (!this.priceElement || !this.regularPriceElement || !this.salePriceElement) {
      console.warn('Price elements are not present in the document.');
      return;
    }

    // Check if selling_plan__item--product-after__list exists if not show the first item
    const sellingPlanList = this.shopifySection.querySelector('.selling_plan__item--product-after__list');
    if (sellingPlanList) {
      let selectedIndex = this.selectedPurchaseOption.getAttribute('data-index');
      if (!selectedIndex) {
        selectedIndex = '1';
      }
      this.shopifySection.querySelectorAll('.selling_plan__item--product-after').forEach(item => {
        if (item.getAttribute('data-index') === selectedIndex) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    }

    if (
      !this.selectedPurchaseOptionComparedAtPrice ||
      this.selectedPurchaseOptionComparedAtPrice === this.selectedPurchaseOptionPrice
    ) {
      this.showRegularPrice();
      this.hideSalePrice();
      this.priceElement.classList.remove('price--on-sale');
      this.updateMirrorPrice(null);
    } else {
      this.showSalePrice();
      this.hideRegularPrice();
      this.priceElement.classList.add('price--on-sale');
      this.updateMirrorPrice(this.selectedPurchaseOptionPrice);
    }
  }

  updateMirrorPrice(price) {
    console.log('updateMirrorPrice', price);
    const mirrorPriceElement = this.querySelector('.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) mirror-price');
    const regularPrice = this.selectedPurchaseOptionComparedAtPrice;

    if (document.querySelectorAll('.optional_product').length > 0) {
      const initialOriginalPrice = parseFloat(this.selectedPurchaseOptionComparedAtPriceAmount);
      const initialSubscriptionPrice = parseFloat(this.selectedPurchaseOptionPriceAmount);
      const productNoMainSellingPlan = this.isSellingPlansFromOptionals;
      let totalOptionalOriginalPrice = 0;
      let totalOptionalSubscriptionPrice = 0;
      let totalWithoutOneTime = 0;
      let containsNonSubscription = false;
      document.querySelectorAll('.optional_product input:checked').forEach((optionalProduct) => {
        const optionalOriginalPrice = optionalProduct.closest('.optional_product').querySelector('[data-original-price]');
        const optionalSubscriptionPrice = optionalProduct.closest('.optional_product').querySelector('[data-subscription-price]')
        totalOptionalOriginalPrice = totalOptionalOriginalPrice + parseFloat(optionalOriginalPrice.dataset.originalPrice);

        if (optionalSubscriptionPrice) {
          totalOptionalSubscriptionPrice = totalOptionalSubscriptionPrice + parseFloat(optionalSubscriptionPrice.dataset.subscriptionPrice);
          totalWithoutOneTime = totalWithoutOneTime + parseFloat(optionalSubscriptionPrice.dataset.subscriptionPrice);
        } else {
          containsNonSubscription = true
          totalOptionalSubscriptionPrice = totalOptionalSubscriptionPrice + parseFloat(optionalOriginalPrice.dataset.originalPrice);
        }
      });

      totalOptionalOriginalPrice = totalOptionalOriginalPrice + initialOriginalPrice;
      totalOptionalSubscriptionPrice = totalOptionalSubscriptionPrice + initialSubscriptionPrice;
      totalWithoutOneTime = totalWithoutOneTime + initialSubscriptionPrice;
      if (productNoMainSellingPlan) {
        totalWithoutOneTime = totalWithoutOneTime - initialSubscriptionPrice;
      }

      if (mirrorPriceElement && this.priceElement.classList.contains('price--on-sale')) {
        mirrorPriceElement.innerHTML = formatMoney(totalOptionalSubscriptionPrice, window.moneyFormat)
          ? `${formatMoney(totalOptionalSubscriptionPrice, window.moneyFormat)} <span class="regular-price-crossed">${formatMoney(totalOptionalOriginalPrice, window.moneyFormat)}</span>`
          : '';
      } else if (mirrorPriceElement && productNoMainSellingPlan) {
        mirrorPriceElement.innerHTML = formatMoney(totalOptionalSubscriptionPrice, window.moneyFormat)
          ? `${formatMoney(totalOptionalSubscriptionPrice, window.moneyFormat)} <span class="regular-price-crossed">${formatMoney(totalOptionalOriginalPrice, window.moneyFormat)}</span>`
          : '';
      }

      if (price !== null || productNoMainSellingPlan) {
        if (containsNonSubscription || productNoMainSellingPlan) {
          // here to display the extra content with non-subscription items appear
          console.log(`Display extra content for non-subscription items`, this);
          this.querySelectorAll('.selling_plan_theme_integration').forEach(item => {
            item.querySelector('.selling_plan__pay-today').classList.remove('hidden');
            item.querySelector('.selling_plan__item--product-after__list').innerHTML = `<div class="selling_plan__item--product-after"> ${this.dataset.thenText} <span class="price__subscription">${formatMoney(totalWithoutOneTime, window.moneyFormat)}</span> ${this.dataset.intervalText}</div>`;
          })

        } else {
          this.querySelectorAll('.selling_plan_theme_integration').forEach(item => {
            item.querySelector('.selling_plan__pay-today').classList.add('hidden');
            item.querySelector('.selling_plan__item--product-after__list').innerHTML = ''
          })
        }
        this.updateOneTimePriceDisplay(totalOptionalOriginalPrice);
      }

    } else {

      if (mirrorPriceElement && this.priceElement.classList.contains('price--on-sale')) {
        mirrorPriceElement.innerHTML = price
          ? `${price} <span class="regular-price-crossed">${regularPrice}</span>`
          : '';
      }
    }
  }

  updateOneTimePriceDisplay(price) {
    console.log('updateOneTimePriceDisplay', price);
    if (price > 0) {
      document.querySelectorAll('.selling_plan__group-list--one-time .selling_plan__item--price').forEach(item => {
        item.innerHTML = formatMoney(price, window.moneyFormat);
      })
    }
  }

  hideSalePrice() {
    this.salePriceElement.style.display = 'none';
  }

  hideRegularPrice() {
    this.regularPriceElement.style.display = 'none';
  }

  showRegularPrice() {
    this.regularPriceElement.style.display = 'block';
    this.shopifySection.querySelector('.price__sale').style.display = 'none';
  }

  showSalePrice() {
    this.salePriceElement.style.display = 'block';
    this.regularPriceValue.innerHTML =
      this.selectedPurchaseOptionComparedAtPrice;
    this.salePriceValue.innerHTML = this.selectedPurchaseOptionPrice;
  }

  get sellingPlanInputs() {
    return this.shopifySection.querySelectorAll('.selected-selling-plan-id');
  }

  updateSellingPlanInputsValues() {
    this.sellingPlanInputs.forEach((sellingPlanInput) => {
      sellingPlanInput.value = this.sellingPlanInputValue;
    });
  }

  get sellingPlanInputValue() {
    return this.selectedPurchaseOption?.dataset.sellingPlanId ?? null;
  }

  get selectedPurchaseOption() {
    const checkedOption = this.visibleSellingPlanForm?.querySelector('input[type="radio"]:checked');
    if (checkedOption) {
      return checkedOption;
    }
    return this.visibleSellingPlanForm?.querySelector('input[type="radio"]');
  }

  set selectedPurchaseOption(selectedPurchaseOption) {
    this._selectedPurchaseOption = selectedPurchaseOption;
  }

  handleRadioButtonChange(selectedPurchaseOption) {
    this.selectedPurchaseOption = selectedPurchaseOption;
    this.lastSelectedPurchaseOption = selectedPurchaseOption;
    this.updateSellingPlanInputsValues();
    this.updatePrice();

    // Remove .active class from all selling_plan__item and selling_plan__group-list elements
    this.shopifySection.querySelectorAll('.selling_plan__item, .selling_plan__group-list').forEach(item => {
      item.classList.remove('active');
    });

    // Add .active class to the parent selling_plan__item and selling_plan__group-list of the checked radio button
    const parentItem = selectedPurchaseOption.closest('.selling_plan__item');
    const parentGroupList = selectedPurchaseOption.closest('.selling_plan__group-list');
    if (parentItem) {
      parentItem.classList.add('active');
    }
    if (parentGroupList) {
      parentGroupList.classList.add('active');
    }

  }

  listenToSellingPlanFormRadioButtonChange() {
    const selectElements = Array.from(
      this.shopifySection?.querySelectorAll('select[name="selling_plan"]') || [],
    );

    this.visibleSellingPlanForm
    ?.querySelectorAll('input[type="radio"]')
    .forEach((radio) => {
      radio.addEventListener('change', (event) => {
        const target = event.target;
        this.handleRadioButtonChange(target);

        if (!selectElements.length) return;

        selectElements.forEach((selectElement) => {
          const valueExists = Array.from(selectElement.options).some(
            (option) => option.value === target.value,
          );
          if (!valueExists) return;

          selectElement.value = target.value;
          selectElement.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  enablePerformanceObserver() {
    const performanceObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.initiatorType !== 'fetch') return;

        const url = new URL(entry.name);
        if (url.search.includes('variant') || url.search.includes('variants')) {
          this.updatePrice();
        }
      });
    });

    performanceObserver.observe({entryTypes: ['resource']});
  }

  selectFirstSubscriptionOption() {
    const firstSubscriptionOption = this.shopifySection.querySelector(
      '.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) input[type="radio"]',
    );

    if (firstSubscriptionOption) {
      firstSubscriptionOption.checked = true;
      this.handleRadioButtonChange(firstSubscriptionOption);
      this.updateMirrorPrice(this.selectedPurchaseOptionPrice);
    }
  }

  toggleAllElements(disable) {
    const elements = this.querySelectorAll('input');
    elements.forEach(element => {
      if (disable) {
        element.setAttribute('disabled', 'true');
        this.classList.add('disabled');
      } else {
        element.removeAttribute('disabled');
        this.classList.remove('disabled');
      }
    });
  }
}

customElements.define('selling-plans-widget', SellingPlansWidget);


class MirrorPlanSelector extends HTMLElement {
  constructor() {
    super();
    this._onSelectChange = null;
  }

  connectedCallback() {
    this.selectElements = Array.from(this.querySelectorAll('select[name="selling_plan"]'));
    this.radioButtons = this.parentElement.querySelectorAll('input[type="radio"][data-radio-type="selling_plan"]');

    if (!this._onSelectChange) {
      this._onSelectChange = (event) => {
        this.syncRadioButtons(event);
      };
    }

    this.selectElements.forEach((selectElement) => {
      selectElement.addEventListener('change', this._onSelectChange);
    });
  }

  disconnectedCallback() {
    if (!this.selectElements?.length || !this._onSelectChange) return;

    this.selectElements.forEach((selectElement) => {
      selectElement.removeEventListener('change', this._onSelectChange);
    });
  }

  syncRadioButtons(event) {
    const selectedValue = event.target.value;
    const selectEl = event.target;
    const index0 = selectEl.selectedIndex;
    const selectedIndex = index0 + 1;

    const radios = Array.from(this.radioButtons || []);
    if (!radios.length) return;

    radios.forEach((radio) => {
      let shouldBeChecked = false;
      if (radio.value === 'null') {
        shouldBeChecked = parseInt(radio.dataset.index) === selectedIndex;
      } else {
        shouldBeChecked = radio.value === selectedValue;
      }

      if (radio.checked !== shouldBeChecked) {
        radio.checked = shouldBeChecked;
        if (shouldBeChecked) {
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }
}

customElements.define('mirror-plan-selector', MirrorPlanSelector);

